export default function replaceUrl(substr, newSubstr, canvasActive) {
  let newPathName;
  newPathName = window.location.pathname.replace(substr, newSubstr);
  // ** This check is needed for Tmall and customizer urls without the customizer.{model}.html url structure **
  newPathName = newPathName.includes(newSubstr) ? newPathName : window.location.href.replace(substr, newSubstr);
  window.history.replaceState({}, document.title, newPathName);
  if(canvasActive) {
    try {
      newPathName = window.parent.location.pathname.replace(substr, newSubstr);
      newPathName = newPathName.includes(newSubstr) ? newPathName : window.parent.location.href.replace(substr, newSubstr);
      window.parent.history.replaceState({}, document.title, newPathName);
    } catch {
      console.log("Replace URL is blocked due to cross origin");
    }
  }
}